export const detailColumn = [
    {
        label: '商品名称',
        prop: 'ettmEbmaNameCn'
    },
    {
        label: '客户商品编码',
        prop: 'ettmCustomerItemNo'
    },
    {
        label: '商品编码',
        prop: 'ettmMaterialNo'
    },
    {
        label: '包装规格',
        prop: 'ettmEbtpPackageType'
    },
    {
        label: '单位',
        prop: 'ettmEbtpPackage'
    },
    {
        label: '单台体积',
        prop: 'ettmPackageVolumn'
    },
    {
        label: '单台重量',
        prop: 'ettmPackageGrossWeight'
    },
    {
        label: '数量',
        prop: 'ettmQuantity'
    },
    {
        label: '体积',
        prop: 'ettmVolume'
    },
    {
        label: '重量',
        prop: 'ettmGrossWeight'
    },
    {
        label: '是否温控',
        prop: 'ettmIsTemperature'
    },
    {
        label: '最低温度',
        prop: 'ettmMinTemperature'
    },
    {
        label: '最高温度',
        prop: 'ettmMaxTemperature'
    },
    {
        label: '最低湿度',
        prop: 'ettmMinHumidity'
    },
    {
        label: '最高湿度',
        prop: 'ettmMaxHumidity'
    }
];